import * as React from "react";
import { schemaBuilderReview } from "../../utils/schema";
export var SchemaReview = function (_a) {
    var poi = _a.poi, canonicalUrl = _a.canonicalUrl;
    var schema = schemaBuilderReview({ poi: poi, canonicalUrl: canonicalUrl });
    return (React.createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: { __html: schema } }));
};



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/components/schema/schemaReview.tsx
// module id = hk/D
// module chunks = 2